import { render, staticRenderFns } from "./CriteriaTemplatePage.vue?vue&type=template&id=43494b83&scoped=true&"
import script from "./CriteriaTemplatePage.vue?vue&type=script&lang=js&"
export * from "./CriteriaTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaTemplatePage.vue?vue&type=style&index=0&id=43494b83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43494b83",
  null
  
)

export default component.exports